import { Component, Injector, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from './shared/components/base.component';
import { Utils } from 'formiojs';
import {
	registerAssessmentComponent,
	registerChartsWrapperComponent,
	registerClassificationIndicatorsComponent,
	registerEditgridResourceComponent,
	registerEventTreeComponent,
	registerFormKeyWrapperComponent,
	registerGroupedTableComponent,
	registerHijriDateComponent,
	registerIndicatorsComponent,
	registerMapComponent,
	registerMasterDetailsResourceComponent,
	registerPDFWrapperComponent,
	registerProccessRequirmentsComponent,
	registerRatingWrapperComponent,
	registerRedirectionButtonComponent,
	registerResourceDropdownWrapperComponent,
	registerStepperComponent,
	registerTableTreeComponent,
	registerTableViewWrapperComponent,
	registerTemplateComponent,
	registerCalenderWrapperComponent,
	registerOrgWrapperComponent,
	registerHtmlEditorComponent,
	registerExecuteVisitComponent,
	registerVisitScheduleComponent,
	registerResourceAutocompleteWrapperComponent,
	registerCardWrapperComponent,
	registerDynamicChartWrapperComponent,
	registerReviewingEvaluationComponent,
} from 'src/formio-custom-components/src/public-api';

import { NavigationStart } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ViewportScroller } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	// styleUrls: ['./app.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class AppComponent extends BaseComponent {
	fullPage$ = of(false);
	windowScrolled = false;
	backToTop = environment.backToTop;

	constructor(public injector: Injector, private viewportScroller: ViewportScroller) {
		super(injector);
		this._registerCustomComponents(injector);
		this.fullPage$ = this.router.events.pipe(
			filter((event) => event instanceof NavigationStart),
			map((event: NavigationStart) => event?.url.includes('reset-password'))
		);
	}

	ngOnInit() {
		this.registerCustomScript();
		this.registerMatmomScript();
		window.addEventListener('scroll', () => {
			this.windowScrolled = window.pageYOffset !== 0;
		});
	}

	private _registerCustomComponents(injector) {
		registerTableTreeComponent(injector);
		registerAssessmentComponent(injector);
		registerTemplateComponent(injector);
		registerMasterDetailsResourceComponent(injector);
		registerProccessRequirmentsComponent(injector);
		registerMapComponent(injector);
		registerIndicatorsComponent(injector);
		registerHijriDateComponent(injector);
		registerFormKeyWrapperComponent(injector);
		registerEditgridResourceComponent(injector);
		registerGroupedTableComponent(injector);
		registerStepperComponent(injector);
		registerRedirectionButtonComponent(injector);
		registerTableViewWrapperComponent(injector);
		registerPDFWrapperComponent(injector);
		registerRatingWrapperComponent(injector);
		registerChartsWrapperComponent(injector);
		registerClassificationIndicatorsComponent(injector);
		registerResourceDropdownWrapperComponent(injector);
		registerEventTreeComponent(injector);
		registerCalenderWrapperComponent(injector);
		registerOrgWrapperComponent(injector);
		registerHtmlEditorComponent(injector);
		registerExecuteVisitComponent(this.injector);
		registerVisitScheduleComponent(injector);
		registerResourceAutocompleteWrapperComponent(injector);
		registerCardWrapperComponent(injector);
		registerDynamicChartWrapperComponent(injector);
		registerReviewingEvaluationComponent(injector);
	}

	scrollTo(elementId) {
		this.viewportScroller.scrollToAnchor(elementId);
	}

	private registerCustomScript() {
		if (environment.enableFormioHelpers) {
			const script = window.document.createElement('script');
			script.src = 'assets/js/formio-helpers.js';
			script.type = 'module';
			window.document.body.appendChild(script);
		}
	}

	private registerMatmomScript() {
		if (environment.matomoConfig?.enable) {
			forkJoin([
				this.configService.getFile(`/assets/js/matomo/matomo.js`),
				this.configService.getFile(`/assets/js/matomo/matomo-noscript.js`),
			]).subscribe(([jsRaw, otherRaw]) => {
				const userId = this.sessionService.getUsername();
				const jsContent = Utils.interpolate(jsRaw, {
					config: environment.matomoConfig,
					userId: userId || 'guest',
				});
				const script = window.document.createElement('script');
				script.append(jsContent);
				window.document.body.appendChild(script);

				const otherContent = Utils.interpolate(otherRaw, { config: environment.matomoConfig });
				const noscript = window.document.createElement('noscript');
				noscript.append(otherContent);
				window.document.body.appendChild(noscript);
			});
		}
	}
}
